module.exports = __webpack_public_path__ + "static/img/userbg.fc5bb18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/userbg.png
// module id = EnzH
// module chunks = 1